import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=3885120c&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=js&"
export * from "./Legal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885120c",
  null
  
)

export default component.exports